/**
 * Two letters for a person's disc: the first letter of the first and of the last word — the rule
 * every avatar in the product follows (feature 040 lifted it out of three components).
 * A missing name yields an em dash, never a fixture.
 */
export function iniciaisDe(nome: string | undefined): string {
  if (!nome) return '—';
  const partes = nome.split(/[\s@.]+/).filter(Boolean);
  const primeira = partes[0]?.[0] ?? '';
  const ultima = partes.length > 1 ? (partes[partes.length - 1]?.[0] ?? '') : '';
  return (primeira + ultima).toUpperCase();
}

/** The honest name for a session: the registered name, else the e-mail's local part, else nothing. */
export function nomeDaSessao(
  claims: { nome?: string | undefined; email?: string | undefined } | null | undefined,
): string {
  if (!claims) return '';
  if (claims.nome) return claims.nome;
  return claims.email?.split('@')[0] ?? '';
}
